import { SET_TAG_LIST } from './types.js'

export default {
  [SET_TAG_LIST] (state, tag_list) {
    state.tag_list = tag_list
  }
}
